import { render, staticRenderFns } from "./NoteTemplate.vue?vue&type=template&id=905bcaa4&"
import script from "./NoteTemplate.vue?vue&type=script&lang=js&"
export * from "./NoteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports